import { getViewRevisionFromProps } from './ViewRevision';
export function extractRefFromProps(props) {
    let ref;
    const revision = getViewRevisionFromProps(props);
    if (revision && 'ref' in revision) {
        ref = revision.ref;
        delete revision.ref;
    }
    return [
        ref,
        props
    ];
}

//# sourceMappingURL=extractRefFromProps.js.map